import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

export const GetChat = createAsyncThunk(
  'chat-list',
  async ({rec_id, model_type}: {rec_id: string; model_type: string}, thunkAPI) => {
    try {
      const response = await axios.get(`/api/chat/list/${rec_id}/${model_type}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createChat = createAsyncThunk('chat-create', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/chat/store', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const DuaAdminContacts = createAsyncThunk(
  'dua-admin-contacts',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/chat/dua-admin-contacts/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DuaLecContacts = createAsyncThunk('dua-lec-contacts', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/chat/dua-lec-contacts/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const DphsAdminContacts = createAsyncThunk(
  'dphs-admin-contacts',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/chat/dphs-admin-contacts/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DphsLecContacts = createAsyncThunk(
  'dua-lec-contacts',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/chat/dphs-lec-contacts/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const UserMsgCount = createAsyncThunk('count-messages', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/chat/user-msg-count')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ContactList = createAsyncThunk('contact-list', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/chat/contact-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MessageRead = createAsyncThunk('read-msg', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/chat/message-read/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const DuaStdContacts = createAsyncThunk('dua-std-contacts', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/chat/dua-std-contacts/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const DphsStdContacts = createAsyncThunk(
  'dphs-std-contacts',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/chat/dphs-std-contacts/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PendingMessages = createAsyncThunk('pending-msg', async (id: any, thunkAPI) => {
  try {
    const response = await axios.get(`/api/chat/pending-message/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type chatState = {
  records: any
  errors: any
  msgCount: any
  contactsList: any
}

const initialState: chatState = {
  records: {
    data: [],
  },
  errors: '',
  msgCount: '',
  contactsList: [],
}

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(UserMsgCount.fulfilled, (state, action: PayloadAction<any>) => {
        state.msgCount = action.payload
      })
      .addCase(ContactList.fulfilled, (state, action: PayloadAction<any>) => {
        state.contactsList = action.payload
      })
      .addCase(PendingMessages.fulfilled, (state, action: PayloadAction<any>) => {
        state.contactsList = action.payload.contacts
        state.msgCount = action.payload.total_unread
      })
  },
})

export const {reset} = chatSlice.actions
export default chatSlice.reducer
